exports = module.exports = require("../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".modal-btn[data-v-217a9c53]{margin:12px 0 0;font-weight:500;min-width:unset;background-color:#006aff!important;color:#fff;height:unset;padding:8px 16px;font-size:12px;letter-spacing:.5px}.adder-card[data-v-217a9c53]{padding:24px;border-radius:9px;-webkit-box-shadow:0 3px 10px 4px rgba(0,106,255,.08),0 2px 2px 0 rgba(0,83,199,.09),0 1px 5px 0 rgba(0,83,199,.09);box-shadow:0 3px 10px 4px rgba(0,106,255,.08),0 2px 2px 0 rgba(0,83,199,.09),0 1px 5px 0 rgba(0,83,199,.09)}.package-note[data-v-217a9c53]{text-align:right}.package-note .material-icons[data-v-217a9c53]{color:#006aff;font-size:20px;position:relative;top:4px}", ""]);

// exports
